import React from 'react'

import { Grid as GridBase, Divider as DividerBase, styled } from '@mui/material'
import { Card as CardBase } from '@chilecompra/react-kit/components'

export const Divider = styled(DividerBase)``

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: ${props => props.width};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: ${props => props.width};
  }
`

export const Card = styled(CardBase)`
  &.MuiPaper-root {
    border-bottom: 0;
    border-radius: 0;
  }

  &.MuiPaper-root:first-of-type {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:nth-last-of-type(2) {
    border-bottom: 1px solid ${props => props.theme.palette.brand.gray2};
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
`
